// extracted by mini-css-extract-plugin
export default {"title":"ConfirmSetOwnerDialog_title__KNNje","icon":"ConfirmSetOwnerDialog_icon__Sq4gn"};